<template>
  <div class="pt-4 px-3 p-3 div-filters">
      <div id="config" class="flex flex-col border  p-4 rounded-lg bg-white">
          <div class="flex flex-row">
              <div  class="flex w-full">

                <v-select v-if="config.filters.elements.search.dropdowns" v-model="config.filters.elements.search.dropdowns.value" label="name" :options="config.filters.elements.search.dropdowns.values" class="rounded-l-lg  z-1 min-w-28  py-2.5 p-2 pr-0 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"></v-select>
               
                <input :placeholder="config.filters.elements.search.dropdowns?config.filters.elements.search.dropdowns.value.name||'...':config.filters.elements.search.options.hint"  @keyup.enter="trigger"  v-model="searchText" type="search" autofill="off" :class="config.filters.elements.search.dropdowns?'rounded-r-lg':'rounded-l-md'"  class="border-t  text-gray-700  text-xs border-b border-l  w-full focus:outline-none py-1 px-4">
                <button  @click="search"  ref="sendReply" class="bg-white rounded-r-md text-blue-500 border-t border-r border-b hover:opacity-75  px-3 focus:outline-none">
                    <i class=" py-1 material-icons">search</i> 
                </button>
              </div>
             
              <div class="" v-if="currentUser.type !='CallenterManager'">
                <button @click="showMore = !showMore" class="text-white hover:bg-gray-400  
                rounded-full  bg-blue-500 flex items-center focus:outline-none p-2 ml-2">
                    <i v-if="showMore" class="material-icons">keyboard_arrow_up</i>
                    <i v-else class="material-icons">keyboard_arrow_down</i>
                </button>
              </div>
          </div>
          <div class="flex flex-col" v-if="showMore">
              <div class="flex flex-row space-x-3 justify-center flex-wrap">
                <div v-for="(item, index) in config.filters.elements.champs" :key="index" v-show="isShown(item)"> 
                  <div v-if="getShow(item.key)  && item.key != 'from' && item.key != 'to'"  class="w-56 mb-4 mt-6" >
                    <div class="border  h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p><label for="seller" class="bg-white text-gray-700 px-1">{{item.label}} <span :class="$colors.required">*</span></label></p>
                        </div>
                        <div v-if="item.type == 'select' && getShow(item.key)">
                          <div v-if="item.name">
                            <span v-if="item.key=='product'">
                               <v-select @search="getProducts($event)" :label="item.name" v-model="filter[item.key]" :options="products" ></v-select>
                            </span>
                             <span v-else>
                                <v-select  :class="config.name==='orders' && item.key==='status_pending' && (!checkstatusorder || (checkstatusorder && checkstatusorder!='Pending' && checkstatusorder!='Unreached'))?'disabled':''" @input="CheckSellerProducts" @search="getUsers($event,item.key)"  :label="item.name" v-model="filter[item.key]" :options="item.values" ></v-select>
                            </span>
                           
                          </div>
                          <div v-else>
                              <v-select  v-model="filter[item.key]" :options="item.values" ></v-select>                           
                          </div>
                        </div>    
                        <div v-else-if="item.type == 'number'" >
                            <input :min="item.min" :step="item.step" v-model="filter[item.key]" :type="item.type"  :name="item.key" :id="item.key" :class="item.class">
                        </div>
                        <div v-else-if="item.type == 'range_numbers'" >
                         
                         <MultiRangeSlider
                           :min="0"
                           :max="12"
                           baseClassName="multi-range-slider-bar-only"
                          :minValue="(item.value && item.value.min) || 0"
                          :maxValue="(item.value && item.value.max) || 12"
                           @input="UpdateValues"
                         />
                       </div>
                        <div v-else>
                            <input v-if="item.type != 'date_range'"  v-model="filter[item.key]" :type="item.type"  :name="item.key" :id="item.key" :class="item.class">
                            <date-picker v-else :placeholder="item.placeholder" @change="DateRange" format="YYYY-MM-DD"  class="w-full-imp" v-model="filter[item.key]" range></date-picker>
                        </div> 
                      
                    </div>
                  </div>
               </div>  
              </div>
               <div v-if="config.filters.hasFilterdate && currentUser.type!= 'Accountant'" class="flex flex-row space-x-3 justify-center flex-wrap">
                  <div v-for="(item, index) in config.filters.elements.champs" :key="index" v-show="isShown(item)"> 
                  <div v-if="getShow(item.key) && (item.key == 'from' || item.key == 'to')"  class="w-56 py-2" >
                    <div class="border  h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                            <p><label for="seller" class="bg-white text-gray-700 px-1">{{item.label}} <span :class="$colors.required">*</span></label></p>
                        </div>
                            <input  v-model="filter[item.key]" :type="item.type"  :name="item.key" :id="item.key" :class="item.class">
                    </div>
                  </div>
               </div> 
              </div>
              <div class="flex flex-row justify-center space-x-2 mt-1">
                
                <button  @click="ClearFilters" class="text-blue-500 rounded-md mx-1 border border-gray-100 
                 bg-gray-300 hover:bg-blue-600  w-1/6 hover:text-white py-2 px-4 focus:outline-none loidingconfirm relative" :class="loading?'noselect':''">
                    Reset
                </button>
                <button v-if="config.filters.elements.champs.length>0" @click="filtrer_saerch" class="rounded-md mx-1 border border-gray-100 
                 bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 w-1/6 focus:outline-none loidingconfirm relative" :class="loading?'noselect':''">
                    Filtrer
                </button>
                
              </div>

          </div>

      </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
export default {
  mixins: [clickaway],
  props: {
    config: { required: true, type: Object},
    currentUser: { type: Object },
    idWharhouse: { type: Object },
    productsarray:{ type: Array },
    name:{type:String},
    loading:{required:false},
  },
  data() {
    return {
      showMore: false,
      searchText: "",
      filter: {},
      products:this.productsarray,
      sellerSelected:null,
      checkstatusorder:null,
      fullPage: false,
      open:false
    };
  },
  watch: {
      'productsarray': async function(oldVal, newVal) {
        this.products=this.productsarray;
      }
  },
  async mounted() {
    this.config.filters.elements.champs.forEach((filter) => {
      if (filter.value)
        this.$set(this.filter, filter.key, filter.value, filter.values);
    });
    
   
  },
  methods: {
    UpdateValues(e) {
      this.barMinValue = e.minValue;
      this.barMaxValue = e.maxValue;
      if(!this.filter.range_numbers) this.filter.range_numbers={};
     // console.log('filter 11----',this.filter)
      this.filter.range_numbers.min=e.minValue;
      this.filter.range_numbers.max=e.maxValue;
    //  console.log('UpdateValues filter----',this.filter)
    },
  DateRange(data){
    //console.log('data date-------------------', data.map( el => this.$moment(el).format('yyyy-MM-DD')))
   // console.log('data date-------------------', data)
    //console.log('data date 00-------------------',this.$moment(data[0]).format('yyyy-MM-DD'))
   // console.log('Range_updatedAt------',this.filter['Range_updatedAt'])
   // console.log('Range_date------',this.filter['Range_date'])
   
  },
  away() {
      this.open = false;
    },
   getUsers: _.debounce(async function(name,type) {
    //  console.log('event______________',name)
     //console.log('warhouset______________',type)
        if(type=="seller" || type=="courier" || type=="zone"){
          await this.$store.dispatch('wharhouse/searchUser',{type: type,warhouse:this.idWharhouse._id,search:name}).then((res) => {
            console.log('res-----------',res)
            const objIndex = this.config.filters.elements.champs.findIndex((obj => obj.key == type));
            this.config.filters.elements.champs[objIndex].values = res
          })
        }
   }, 500), 
   getProducts: _.debounce(async function(name) {
     console.log('event______________',name)
     const filterParams=this.$f.QueryStringToobject();
      console.log('filterParams______________',filterParams)
     const filter={seller: this.sellerSelected,warhouse:this.idWharhouse._id,search:name,notPopulate:true};
     if(filterParams.seller) filter.seller=filterParams.seller;
        await this.$store.dispatch('wharhouse/searchProducts',filter).then((res) => {
            this.products = res;
        })
   }, 500), 
   async CheckSellerProducts(seller){
    console.log('seller----------',seller)
     if(this.name=="orders" && seller && seller.name && seller.env){
         this.checkstatusorder=seller.name;
         console.log('checkstatusorder-----',this.checkstatusorder)
      }
      if((this.name=="shippings" || this.name=="orders") && seller && seller.warehouses && seller.type){
        this.products = [];
        this.sellerSelected=seller._id;
        const res = await this.$server.search("products", { seller: seller._id,limit:10,notPopulate:true });
        if (res && res.content.results) {
          this.products = res.content.results;
        } else {this.products = [];this.sellerSelected=null}
      }
    },
    trigger() {
      this.$refs.sendReply.click();
    },
     getShow(champ){
       if((champ==="seller" || champ==="courier" || champ==="zone") && this.currentUser.type ==="Seller") return false
       else if((champ==="seller" || champ==="product") && this.currentUser.type ==="Accountant") return false
       else return true
     },
      reset: function (val) {
          this.$emit('reset',val);
      },
      filtrer: function (val) {
          this.$emit('filtrer',val);
      },
      search: function () {
         if(!this.loading){
          if(!this.searchText){
            alert("Value empty !!", "warning");
            return false;
          }
          let dataFilterVlaue=null;
          if(this.config.filters.elements.search.dropdowns){
             if(!this.config.filters.elements.search.dropdowns.value){
                alert("Filter value required !!", "warning");
                return false;
             }else dataFilterVlaue=this.config.filters.elements.search.dropdowns.value;
              
          }
          console.log('dataFilterVlaue value ---',dataFilterVlaue)
          this.$emit('search',this.searchText,dataFilterVlaue);
         } 
      },
      isShown(item) {
      let shown =
        !item.show ||
        (item.show && this.filter[item.show.key] == item.show.equal);
      if (!shown) this.$set(this.filter, item.key, null);
      return shown;
    },
    searc() {
      //console.log(this.articleType);
    },

    /*********************************************************************************** */
     async filtrer_saerch() {
      this.filtrer(this.filter);
    },
    async ClearFilters() {
      console.log('oook')
      this.reset(this.filter);
      this.filter = {};
    },
  },
};
</script>

<style scoped>
.w-200{
  width: 200px;
}
</style>